export default {"src":"/_next/static/media/tag-hat.f2f45ede.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};